import { Component, OnInit, Input } from '@angular/core';
import { identity } from 'rxjs';

@Component({
  selector: 'lib-country-flag',
  templateUrl: './country-flag.component.html',
  styleUrls: ['./country-flag.component.scss']
})
export class CountryFlagComponent implements OnInit {
  @Input()
  id:string;
  @Input()
  name:string;
  @Input()
  nameRight:string;
  constructor() { }

  ngOnInit() {
    if(this.id==undefined){
      console.warn("property id it's not defined please bind property <lib-country-flag [id]='your-data'")
    }
  }

}
